import { useEffect, useState } from "react";

const BREAKING = [
  "顶流小生深夜离场画面流出，同车人身份成谜",
  "国民小花连夜注销工作室账号，圈内集体噤声",
  "红毯后台连续三年被爆内定奖杯，这次证据更实",
  "某影帝庆功宴后失联三天，经纪人电话拒接",
  "新瓜预告：明早 9 点放「白月光」系男神旧视频",
];

const NAV = [
  { href: "#top", label: "首页" },
  { href: "#hot", label: "热瓜榜" },
  { href: "#feed", label: "猛料现场" },
  { href: "#deep", label: "独家深扒" },
  { href: "#brief", label: "圈内速递" },
  { href: "#people", label: "主角档案" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header id="top" className="relative z-40">
      {/* breaking ticker */}
      <div className="bg-primary-700 text-background-50">
        <div className="mx-auto flex max-w-[1240px] items-center gap-3 px-4 py-1.5 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-[13px] font-bold">
            <i className="ri-flashlight-fill w-4 h-4 flex items-center justify-center" />
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker gap-12 pr-12 text-[13px]">
              {[...BREAKING, ...BREAKING].map((t, i) => (
                <span key={i} className="whitespace-nowrap text-background-50/90">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`sticky top-0 transition-colors duration-300 ${
          scrolled ? "border-b border-background-200/80 bg-background-50/95 backdrop-blur" : "bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-[64px] max-w-[1240px] items-center justify-between gap-4 px-4 md:px-6">
          {/* brand / logo wraps H1 */}
          <a href="#top" className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-sparkling-2-fill text-lg" />
            </span>
            <h1 className="font-heading text-xl font-black tracking-wide text-foreground-950 md:text-2xl">
              海角<span className="text-primary-600">天崖</span>
            </h1>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 md:flex">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="rounded-md px-3 py-2 text-[15px] font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2.5 md:flex">
            <a
              href="#report"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-600 px-3.5 py-2 text-[14px] font-bold text-background-50 transition-colors hover:bg-secondary-700"
            >
              <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
              下载 App
            </a>
            <a
              href="#report"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-[14px] font-bold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
              我要爆料
            </a>
            <button
              type="button"
              className="ml-1 flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100"
              aria-label="搜索"
            >
              <i className="ri-search-line w-5 h-5 flex items-center justify-center" />
            </button>
          </div>

          {/* mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 md:hidden"
            aria-label="菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} w-6 h-6 flex items-center justify-center`} />
          </button>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
            <nav className="mt-2 grid grid-cols-2 gap-2">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md bg-background-100 px-3 py-2.5 text-[15px] font-medium text-foreground-800"
                >
                  {n.label}
                </a>
              ))}
            </nav>
            <a
              href="#report"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-[15px] font-bold text-background-50"
            >
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
              我要爆料 · 下载 App
            </a>
          </div>
        )}
      </div>
    </header>
  );
}